export default "__VITE_ASSET__DLQsze7g__"